module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('p', {
    staticClass: "ebook-toc",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "text-italic CharOverride-1"
  }, [_vm._v("To Gehad.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame pb",
    attrs: {
      "id": "_idContainer004"
    }
  }, [_c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("From His signs is that amongst yourselves He  created spouses for you to find tranquility in them;  and He put affection and mercy between you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1 t"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("(Quran 30:21)")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 t2"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "alt": "",
      "src": "image/Arranged--03.png"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71c25ee8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Arranged_ebook1.vue
// module id = 63
// module chunks = 0